var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBpayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 74 35",
    style: {
      enableBackground: "new 0 0 74 35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A2652;}\n\t.st1{fill:#FFFFFE;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Moving-Parts"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x32__x5F_pay_x5F_with_x5F_bpay",
    transform: "translate(-296.000000, -408.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add_to_xero",
    transform: "translate(295.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 116.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(0.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M71.6,1H1.4C0.6,1,0,1.6,0,2.4v31.2C0,34.4,0.6,35,1.4,35h70.3c0.8,0,1.4-0.6,1.4-1.4V2.4 C73,1.6,72.4,1,71.6,1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    className: "st1",
    d: "M67.2,8.2c-0.9,0-1.3,0-1.7,0c-0.4,0-0.9,0.1-1.1,0.7l-0.8,1.5l-3.3,5.9L57,10.4L56.1,9 c-0.2-0.7-0.7-0.7-1.1-0.7c-0.4,0-0.8,0-1.7,0S52.7,9,52.7,9s3.3,6,6,10.9c0,0,0,5.8,0,6.2c0,0.4,0.2,0.7,0.6,0.7h1.6 c0.3,0,0.8,0,0.8-0.6V20c2.7-4.9,6-10.9,6-10.9S68.1,8.2,67.2,8.2z M72,32.3c0,0.4-0.2,0.7-0.7,0.7H2.6l0,0 C2.2,33,2,32.7,2,32.4c0,0,0-12.8,0-21.6h7.2l-2.9,1.1v16.2c0,0.5,0.2,0.7,0.6,0.7h9.8c3.3-0.1,6-2.9,6-6.3 c0-2.2-1.2-4.2-2.9-5.3c1.1-1,1.9-2.6,1.9-4.2c0-4.2-2.9-6.6-7.1-6.6h-4.1V2c18.1,0,60.8,0,60.8,0C71.8,2,72,2.4,72,2.7V32.3 z M2,2.7L2,2.7C2,2.3,2.2,2,2.6,2c0,0,1.4,0,3.7,0v4.4H2C2,4.1,2,2.7,2,2.7z M10.5,10.6h4.7c1.2,0,2.2,1.1,2.2,2.3 c0,1.2-1,2.3-2.2,2.3h-0.8c-0.4,0-0.7,0.3-0.7,0.7v2.8c0,0.4,0.3,0.7,0.7,0.7h2c1.3,0,2.4,1.1,2.4,2.5c0,1.3-1,2.3-2.2,2.4 h-5.4c-0.4,0-0.7-0.2-0.7-0.7C10.5,23.6,10.5,10.6,10.5,10.6z M72.6,0H1.4C0.6,0,0,0.6,0,1.4v32.2C0,34.4,0.6,35,1.4,35h71.3 c0.8,0,1.4-0.6,1.4-1.4V1.4C74,0.6,73.4,0,72.6,0z M33.4,17.1h-4.2v-5.9h4.2c1.6,0,2.9,1.3,2.9,2.9 C36.2,15.8,34.9,17.1,33.4,17.1z M33.4,8.3h-6.6c-0.6,0-0.7,0.5-0.7,0.8s0,17,0,17c0,0.7,0.6,0.7,0.7,0.7h1.7 c0.3,0,0.6-0.2,0.6-0.6v-6.1h4.3c3.2,0,5.8-2.6,5.8-5.9S36.6,8.3,33.4,8.3z M43.7,19.9l3-8.6l3.2,8.6H43.7z M48.9,9 c-0.2-0.5-0.4-0.8-1.2-0.8h-2.1c-0.8,0-1,0.3-1.2,0.8s-6.2,17-6.2,17s-0.4,0.7,0.5,0.7s1.1,0,1.5,0s0.9-0.1,1.1-0.7 c0.2-0.6,1.1-3.1,1.1-3.1h8.4c0,0,0.9,2.5,1.1,3.1c0.2,0.7,0.7,0.7,1.1,0.7c0.4,0,0.6,0,1.5,0s0.6-0.7,0.6-0.7 S49.1,9.5,48.9,9z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBpayLogo);
export default __webpack_public_path__ + "static/media/bpay-logo.071699feacef3fa6bcae102a13524bb7.svg";
export { ForwardRef as ReactComponent };